import { Injectable } from '@angular/core';
import { TariffService } from './tariff.service';
import { TariffDetail } from '../models/tariff-detail.model';
import { EntityDetailResolver } from 'src/app/core/services/entity-detail.resolver';


@Injectable({ providedIn: 'root' })
export class TariffDetailResolver extends EntityDetailResolver<TariffService, TariffDetail> {
  constructor(
    tariffService: TariffService
  ) {
    super(tariffService)
  }
}
